import React, { useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';

const SearchableDropdown = ({ options = [], onSelect, label = 'Select an option', onCreateNew }) => {
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);

  const filteredOptions = options?.filter(option => option.label.toLowerCase().includes(search.toLowerCase()));

  const handleSelect = value => {
    setSelected(value);
    onSelect(value?.value);
  };

  return (
    <Dropdown style={{ minWidth: '250px' }}>
      <Dropdown.Toggle variant="transparent" style={{ width: '100%' }}>
        <b>{selected ? selected.label : label}</b>
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ width: '100%', padding: '0' }}>
        <Form.Control
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #ced4da',
            borderRadius: '4px',
            marginBottom: '8px'
          }}
          type="text"
          placeholder="Search..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          aria-label="Search options"
        />
        <div
          style={{
            maxHeight: '300px',
            overflowY: 'auto',
            padding: '0 8px'
          }}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map(option => (
              <Dropdown.Item
                key={option.value}
                onClick={() => handleSelect(option)}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  borderRadius: '4px',
                  marginBottom: '4px',
                  transition: 'background-color 0.2s',
                  ':hover': {
                    backgroundColor: '#f8f9fa'
                  }
                }}
              >
                {option.label}
              </Dropdown.Item>
            ))
          ) : (
            <div
              style={{
                padding: '8px 12px',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}
            >
              <div style={{ color: '#6c757d' }}>No options found</div>
              <button
                className="btn btn-primary btn-sm"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onCreateNew && onCreateNew(search);
                }}
              >
                Create "{search}"
              </button>
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SearchableDropdown;
